"use strict";

exports.__esModule = true;
exports.default = void 0;

var _AppIcon = require("./AppIcon");

exports.getAppIcon = _AppIcon.getAppIcon;

var _UserIcon = require("./UserIcon");

exports.getUserIcon = _UserIcon.getUserIcon;

var _OwnerIcon = _interopRequireWildcard(require("./OwnerIcon"));

exports.getOwnerIcon = _OwnerIcon.getOwnerIcon;
exports.OwnerIcon = _OwnerIcon.default;

var _AdminIcon = _interopRequireDefault(require("./AdminIcon"));

exports.AdminIcon = _AdminIcon.default;

var _AnalyticsIcon = _interopRequireDefault(require("./AnalyticsIcon"));

exports.AnalyticsIcon = _AnalyticsIcon.default;

var _DashboardIcon = _interopRequireDefault(require("./DashboardIcon"));

exports.DashboardIcon = _DashboardIcon.default;

var _InboxIcon = _interopRequireDefault(require("./InboxIcon"));

exports.InboxIcon = _InboxIcon.default;

var _CalendarIcon = _interopRequireWildcard(require("./CalendarIcon"));

exports.CalendarIcon = _CalendarIcon.default;
exports.getCalendarIcon = _CalendarIcon.getCalendarIcon;

var _ForumIcon = _interopRequireDefault(require("./ForumIcon"));

exports.ForumIcon = _ForumIcon.default;

var _SupportIcon = _interopRequireDefault(require("./SupportIcon"));

exports.SupportIcon = _SupportIcon.default;

var _ProfileIcon = _interopRequireWildcard(require("./ProfileIcon"));

exports.ProfileIcon = _ProfileIcon.default;
exports.getProfileIcon = _ProfileIcon.getProfileIcon;

var _SettingsIcon = _interopRequireDefault(require("./SettingsIcon"));

exports.SettingsIcon = _SettingsIcon.default;

var _M24Icon = _interopRequireDefault(require("./M24Icon"));

exports.Museum24Icon = _M24Icon.default;

var _DmIcon = _interopRequireDefault(require("./DmIcon"));

exports.DigitaltMuseumIcon = _DmIcon.default;

var _KpIcon = _interopRequireDefault(require("./KpIcon"));

exports.KulturPunktIcon = _KpIcon.default;

var _KompassIcon = _interopRequireDefault(require("./KompassIcon"));

var _PrimusIcon = _interopRequireDefault(require("./PrimusIcon"));

exports.PrimusIcon = _PrimusIcon.default;

var _KulturnavIcon = _interopRequireDefault(require("./KulturnavIcon"));

exports.KulturNavIcon = _KulturnavIcon.default;

var _MinnerIcon = _interopRequireDefault(require("./MinnerIcon"));

exports.MinneIcon = _MinnerIcon.default;
exports.MinnerIcon = _MinnerIcon.default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = {
  "dashboard": _DashboardIcon.default,
  "inbox": _InboxIcon.default,
  "calendar": _CalendarIcon.default,
  "forum": _ForumIcon.default,
  "support": _SupportIcon.default,
  "analytics": _AnalyticsIcon.default,
  "admin": _AdminIcon.default,
  "profile": _ProfileIcon.default,
  "settings": _SettingsIcon.default,
  "m24": _M24Icon.default,
  "museum24": _M24Icon.default,
  "dm": _DmIcon.default,
  "digitaltmuseum": _DmIcon.default,
  "ko": _KompassIcon.default,
  "kompass": _KompassIcon.default,
  "kp": _KpIcon.default,
  "kulturpunkt": _KpIcon.default,
  "pr": _PrimusIcon.default,
  "primus": _PrimusIcon.default,
  "kn": _KulturnavIcon.default,
  "kulturnav": _KulturnavIcon.default,
  "mi": _MinnerIcon.default,
  "minne": _MinnerIcon.default,
  "minner": _MinnerIcon.default
};
exports.default = _default;